<template>
	<div class="absolute inset-0 z-50 bg-white !bg-opacity-70 flex flex-col items-center justify-center h-100vh overflow-hidden">
		<div class="dual-ring-spinner"></div>
		<div class="text-gray-500 font-semibold mt-5">{{ displayMessage }}</div>
	</div>
</template>

<script setup lang="ts">
import { messages } from '@/assets/language'
import { useAppStore } from '@/stores/app-store'
import { computed, onMounted, onBeforeUnmount } from 'vue'

const props = defineProps<{
	assistantLoadingMsg?: string
}>()

const { currentLng } = useAppStore()

const labels = computed(() => {
	const key = currentLng.value as keyof typeof messages
	return messages[key] ?? {}
})

const displayMessage = computed(() => props.assistantLoadingMsg || `${labels.value.loading}...`)

onMounted(() => {
	document.body.style.overflow = 'hidden'
})

onBeforeUnmount(() => {
	document.body.style.overflow = ''
})

</script>

<style lang="css" scoped>
.dual-ring-spinner {
  display: inline-block;
  width: 60px;
  height: 60px;
}
.dual-ring-spinner:after {
  content: " ";
  display: block;
  width: 60px;
  height: 60px;
  margin: auto;
  border-radius: 50%;
  border: 4px solid #333;
  border-color: #333 transparent #333 transparent;
  animation: dual-ring 1.2s linear infinite;
}
@keyframes dual-ring {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
